import { render, staticRenderFns } from "./SharePrescriptionDialog.vue?vue&type=template&id=4f018632"
import script from "./SharePrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./SharePrescriptionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports